import React, { useState } from "react";
import useRouter from "../../hooks/router";

const NAV_BG = "rgba(14, 24, 38, 0.72)";
const CARD_BG = "rgba(19, 31, 47, 0.82)";
const TEXT_MAIN = "#f2f7fb";
const TEXT_MUTED = "#9db3c7";
const BORDER = "rgba(255,255,255,0.10)";
const ACCENT = "#48e0c2";
const SALES_EMAIL = "openclawrefalign@gmail.com";
const CAL_COM_EMBED_URL = "https://cal.com/";

const Booking = () => {
  const { handleNavigation } = useRouter();
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    const subject = encodeURIComponent("RefAlign demo request");
    const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\nOrganization: ${form.company}\n\nMessage: ${form.message}`);
    const mailto = `mailto:${SALES_EMAIL}?subject=${subject}&body=${body}`;
    window.location.href = mailto;
    setSubmitted(true);
  };


  return (
    <div style={{ background: "radial-gradient(circle at top, rgba(72,224,194,0.10), transparent 28%), linear-gradient(180deg, #0b1220 0%, #101827 100%)", minHeight: "100vh" }} className="font-outfit flex flex-col overflow-x-hidden">
      <nav style={{ background: NAV_BG, backdropFilter: "blur(18px)", borderBottom: `1px solid ${BORDER}` }} className="w-full px-4 sm:px-6 py-4 flex items-center justify-between shadow-md sticky top-0 z-50">
        <img src="/logo.svg" alt="RefAlign" className="h-9 cursor-pointer" onClick={() => handleNavigation("/")} />
        <button onClick={() => handleNavigation("/")} style={{ color: TEXT_MAIN, border: `1px solid ${BORDER}` }} className="px-4 py-2 rounded-lg text-sm hover:bg-white hover:bg-opacity-5 transition-all">
          Home
        </button>
      </nav>

      <main className="px-4 sm:px-6 py-10 flex-1 overflow-x-hidden">
        <div className="max-w-3xl mx-auto">
          <section style={{ background: CARD_BG, border: `1px solid ${BORDER}`, boxShadow: "0 30px 80px rgba(0,0,0,0.35)" }} className="rounded-3xl p-6 sm:p-8 shadow-2xl overflow-hidden">
            <div className="mb-8">
              <div style={{ background: "rgba(0,201,167,0.12)", color: ACCENT, border: "1px solid rgba(0,201,167,0.25)" }} className="inline-block px-4 py-1.5 rounded-full text-sm font-medium mb-4">
                Talk to sales
              </div>
              <h1 style={{ color: TEXT_MAIN }} className="text-3xl sm:text-4xl font-bold mb-3">Request a demo</h1>
              <p style={{ color: TEXT_MUTED }} className="text-base leading-relaxed max-w-xl">
                Fill out the questionnaire below and we’ll follow up to book a meeting with our sales team.
                This replaces both “Get Started” and “Book a Demo” so they land in the same place.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4">
              {[
                ["name", "Name", "Your name"],
                ["email", "Email", "you@example.com"],
                ["company", "Organization", "Club, league, or organization"],
              ].map(([key, label, placeholder]) => (
                <div key={key}>
                  <label style={{ color: TEXT_MUTED }} className="block text-xs font-medium mb-1.5">{label}</label>
                  <input
                    value={form[key]}
                    onChange={(e) => setForm((prev) => ({ ...prev, [key]: e.target.value }))}
                    placeholder={placeholder}
                    className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                    style={{ background: "rgba(255,255,255,0.05)", color: TEXT_MAIN, border: `1px solid ${BORDER}` }}
                  />
                </div>
              ))}
              <div>
                <label style={{ color: TEXT_MUTED }} className="block text-xs font-medium mb-1.5">Message</label>
                <textarea
                  value={form.message}
                  onChange={(e) => setForm((prev) => ({ ...prev, message: e.target.value }))}
                  rows="6"
                  placeholder="Tell us what you need and what timing works for you"
                  className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                  style={{ background: "rgba(255,255,255,0.05)", color: TEXT_MAIN, border: `1px solid ${BORDER}` }}
                />
              </div>
              <button
                type="button"
                onClick={handleSubmit}
                style={{ background: ACCENT, color: "#0d2230" }}
                className="w-full py-3 rounded-xl text-sm font-bold hover:opacity-90 transition-all shadow-lg mt-2 text-center"
              >
                Send request
              </button>

              {submitted && (
                <div className="mt-4 rounded-2xl overflow-hidden" style={{ background: "rgba(255,255,255,0.03)", border: `1px solid ${BORDER}` }}>
                  <div className="px-4 py-3" style={{ color: TEXT_MAIN, borderBottom: `1px solid ${BORDER}` }}>
                    <div className="text-sm font-semibold">Thanks — book a time with sales</div>
                    <div className="text-xs mt-1" style={{ color: TEXT_MUTED }}>Your request is sent. Pick a time below.</div>
                  </div>
                  <iframe
                    title="RefAlign sales calendar"
                    src={CAL_COM_EMBED_URL}
                    className="w-full h-[560px] sm:h-[700px]"
                    style={{ border: 0 }}
                  />
                </div>
              )}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Booking;
